import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const ContactInfo = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <div ref={ref} className="bg-gradient-to-br from-[#007dff] to-[#0066cc] text-white p-8 lg:p-12">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
      >
        <h2 className="font-poppins font-bold text-3xl lg:text-4xl mb-3 text-white">
          İletişim Bilgileri
        </h2>
        <p className="font-poppins text-[15px] text-white/80 mb-12">
          Size ulaşmak için birden fazla yol
        </p>

        {/* Contact Info */}
        <div className="space-y-6">
          <motion.a
            href="tel:+905530161235"
            initial={{ opacity: 0, x: -20 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="flex items-center gap-4 p-4 bg-white/10 rounded-xl hover:bg-white/20 transition-all duration-300 cursor-pointer group"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg group-hover:scale-110 transition-transform duration-300">
              <i className="ri-phone-line text-xl text-white"></i>
            </div>
            <div>
              <p className="font-poppins text-sm text-white/70">Telefon</p>
              <p className="font-poppins font-semibold text-lg text-white">
                0553 016 12 35
              </p>
            </div>
          </motion.a>

          <motion.a
            href="mailto:info@sigorota360.com"
            initial={{ opacity: 0, x: -20 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="flex items-center gap-4 p-4 bg-white/10 rounded-xl hover:bg-white/20 transition-all duration-300 cursor-pointer group"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg group-hover:scale-110 transition-transform duration-300">
              <i className="ri-mail-line text-xl text-white"></i>
            </div>
            <div>
              <p className="font-poppins text-sm text-white/70">E-posta</p>
              <p className="font-poppins font-semibold text-lg text-white">
                info@sigorota360.com
              </p>
            </div>
          </motion.a>

          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={inView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="flex items-center gap-4 p-4 bg-white/10 rounded-xl"
          >
            <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-lg">
              <i className="ri-map-pin-line text-xl text-white"></i>
            </div>
            <div>
              <p className="font-poppins text-sm text-white/70">Adres</p>
              <p className="font-poppins font-semibold text-lg text-white">
                Kızılay Mah. Atatürk Bulv. No: 72/16 Çankaya / ANKARA
              </p>
            </div>
          </motion.div>
        </div>

        {/* Social Media */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 pt-8 border-t border-white/20"
        >
          <p className="font-poppins text-sm text-white/70 mb-4">Sosyal Medya</p>
          <div className="flex items-center gap-3">
            <a
              href="https://www.linkedin.com/company/sigorota360"
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-all duration-300 cursor-pointer group"
            >
              <i className="ri-linkedin-fill text-lg text-white group-hover:scale-110 transition-transform duration-300"></i>
            </a>
            <a
              href="https://www.instagram.com/sigorota360/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-11 h-11 flex items-center justify-center bg-white/10 rounded-lg hover:bg-white/20 transition-all duration-300 cursor-pointer group"
            >
              <i className="ri-instagram-line text-lg text-white group-hover:scale-110 transition-transform duration-300"></i>
            </a>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ContactInfo;
